export default {
  request: ({ url, rootUrl, ...other }) => ({
    url: url.match(/https?:\/\//) ? url : `${rootUrl}${url}`,
    ...other,
  }),
}
